import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { DELETE_MEASUREMENT_TECHNOLOGY_MUTATION } from "../../../../graphql/mutations";

const DeleteMeasurementTechModal = ({ show, technology, currentTenant, handleClose, handleEnvChange, env }) => {
  const navigate = useNavigate();
  const [deleteMeasurementTechnology, { loading: mutationLoading }] = useMutation(DELETE_MEASUREMENT_TECHNOLOGY_MUTATION);

  const handleDelete = async (e) => {
    e.preventDefault();

    try {
      const { data } = await deleteMeasurementTechnology({
        variables: {
          id: technology.id
        }
      });

      if (data) {
        handleClose();
        setTimeout(() => {
          toast.success(`Measurement technology deleted successfully`);
          navigate("/measurement-tech");
          handleEnvChange(env, currentTenant);
        }, 200);
      }
    } catch (error) {
      handleClose();
      setTimeout(() => {
        toast.error("Failed to delete measurement technology.");
      }, 200);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Delete Technology</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you want to delete technology <strong>{technology.name}</strong>?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleClose}>
          No
        </Button>
        <Button variant="danger" onClick={handleDelete}>
          {mutationLoading ? "Deleting technology..." : "Yes"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export { DeleteMeasurementTechModal };
